module.exports = __webpack_public_path__ + "img/monitor-gray.503956d2.svg";